import React from 'react';
import ReportsList from './Components/ReportsList/ReportsList';


const Plants = () => {
	return (<ReportsList title={"pages.reports.plans"} url={"/api/reports/plans/"} />);
};

export default Plants;
